// ----------------------------------------------------
// Sticky header registration ribbon (bootstrap affix)
// Top navigation opaque transition
import _throttle from 'lodash-es/throttle';
import _merge from 'lodash-es/merge';

import { $ } from './utils/querySelector';
import { ResizeListener } from './resize-listener';

const DEFAULT_OPTIONS = {
    selector: {
        ribbon: '.ghwp-registration-ribbon',
        header: '.ghwp-header__wrapper',
    },
    stickyBreakpoint: 992,
    stickyRibbonMod: 'fixed-registration-ribbon',
    opaqueShadowMod: 'opaque-shadow',
    headerHeight: 108,
};

export class StickyHeader {
    constructor(resizeListener, userOptions = {}) {
        this.options = {};

        this.headerOffset = false;
        this.ribbonElement = null;
        this.headerElement = null;
        this.stickyToogleOffset = null;

        this.resizeListener = resizeListener || new ResizeListener();
        this.debouncedOnScroll = _throttle(this.onScroll.bind(this), 20);

        this.parseOptions(userOptions);
        this.findElements();
        this.listen();
    }

    addStickyHeader() {
        this.headerOffset = true;
        this.ribbonElement &&
            this.ribbonElement.classList.add(this.options.stickyRibbonMod);
        this.headerElement &&
            this.headerElement.classList.add(this.options.opaqueShadowMod);
    }

    findElements() {
        this.headerElement = $()(this.options.selector.header);
        this.ribbonElement = $()(this.options.selector.ribbon);

        const bodyRect = document.body.getBoundingClientRect();

        if (this.ribbonElement) {
            const ribbonRect = this.ribbonElement.getBoundingClientRect();
            const ribbonYOffset = ribbonRect.top - bodyRect.top;
            this.stickyToggleOffset = ribbonYOffset - this.options.headerHeight;
        } else {
            this.stickyToggleOffset = this.options.headerHeight;
        }
    }

    listen() {
        window.addEventListener('scroll', this.debouncedOnScroll);
    }

    onScroll() {
        const pageYOffset =
            window.pageYOffset || document.documentElement.scrollTop;
        if (this.stickyToggleOffset && pageYOffset >= this.stickyToggleOffset) {
            !this.headerOffset && this.addStickyHeader();
        } else {
            this.headerOffset && this.removeStickyHeader();
        }
    }

    parseOptions(userOptions) {
        this.options = _merge(DEFAULT_OPTIONS, userOptions);
    }

    removeStickyHeader() {
        this.headerOffset = false;
        this.ribbonElement &&
            this.ribbonElement.classList.remove(this.options.stickyRibbonMod);
        this.headerElement &&
            this.headerElement.classList.remove(this.options.opaqueShadowMod);
    }
}
